import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { TokenStorageService } from './token-storage.service';
const API_URL = environment.apiUrl + 'digitalarticle';
@Injectable({
    providedIn: 'root'
})
export class DigitalarticleService {
    authtoken: string;
    private httpOptions;
    constructor(private http: HttpClient, private token: TokenStorageService) {
        this.authtoken = this.token.getToken();
        this.httpOptions = {
            headers: new HttpHeaders()
                .set("Content-Type", "application/json")
                .set('Authorization', `Bearer ${this.authtoken}`)
        };
    }
    getDigitalarticleList(query): Observable<any> {
        return this.http.get(API_URL + query);
    }
    getDigitalarticleDetails(id): Observable<any> {
        return this.http.get(API_URL + '/' + id);
    }
    updateDigitalarticle(id, userdata): Observable<any> {
        return this.http.put(API_URL + '/' + id, userdata);
    }
    addDigitalarticle(digitalarticledata): Observable<any> {
        return this.http.post(API_URL, digitalarticledata);
    }
    uploadDigitalarticleCsv(csvData): Observable<any> {
        return this.http.post(API_URL + '/uploadCSV', csvData);
    }
    uploadDigitalarticleImages(imagesData): Observable<any> {
        return this.http.post(API_URL + '/uploadImages', imagesData);
    }
}